import { render, staticRenderFns } from "./SurveyTemplatePage.vue?vue&type=template&id=3c6af74a"
import script from "./SurveyTemplatePage.vue?vue&type=script&lang=js"
export * from "./SurveyTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./SurveyTemplatePage.vue?vue&type=style&index=0&id=3c6af74a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports